var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6622 33.2751V41.5671H10.7822",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7383 33.2751V41.5671H42.6173",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5146 33.2751V44.3421",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5136 52.6662C28.8122 52.6662 30.6756 50.8028 30.6756 48.5042C30.6756 46.2056 28.8122 44.3422 26.5136 44.3422C24.215 44.3422 22.3516 46.2056 22.3516 48.5042C22.3516 50.8028 24.215 52.6662 26.5136 52.6662Z",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8007 45.7091C49.0993 45.7091 50.9627 43.8457 50.9627 41.5471C50.9627 39.2485 49.0993 37.3851 46.8007 37.3851C44.5021 37.3851 42.6387 39.2485 42.6387 41.5471C42.6387 43.8457 44.5021 45.7091 46.8007 45.7091Z",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62001 45.7091C8.91862 45.7091 10.782 43.8457 10.782 41.5471C10.782 39.2485 8.91862 37.3851 6.62001 37.3851C4.3214 37.3851 2.45801 39.2485 2.45801 41.5471C2.45801 43.8457 4.3214 45.7091 6.62001 45.7091Z",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0274 25.9801C52.0284 27.5666 51.5445 29.1154 50.6405 30.4191C49.7364 31.7228 48.4555 32.719 46.9694 33.2741H8.08841C5.77147 32.5214 3.79893 30.967 2.52525 28.8903C1.25156 26.8136 0.760215 24.3508 1.1395 21.9443C1.51879 19.5379 2.74385 17.3456 4.59454 15.7613C6.44524 14.1771 8.80025 13.3048 11.2364 13.3011C12.1082 13.3009 12.9761 13.4166 13.8174 13.6451C14.1726 10.096 15.8652 6.81495 18.5515 4.46829C21.2377 2.12164 24.7164 0.885221 28.2811 1.01008C31.8459 1.13494 35.2295 2.61171 37.745 5.14056C40.2605 7.66942 41.7194 11.0608 41.8254 14.6261C41.8397 14.7633 41.8453 14.9013 41.8424 15.0391C41.847 16.3072 41.6733 17.5695 41.3264 18.7891C42.2526 18.4008 43.2471 18.2019 44.2514 18.2041C45.2729 18.2031 46.2845 18.4035 47.2284 18.7939C48.1723 19.1843 49.0299 19.7571 49.7522 20.4793C50.4745 21.2016 51.0472 22.0593 51.4376 23.0032C51.828 23.9471 52.0285 24.9587 52.0274 25.9801Z",
    stroke: "#0B192E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature_1.f392caed43ba17ee616d86cfa085b63d.svg";
export { ForwardRef as ReactComponent };